import clsx from "clsx";
import { Dayjs } from "dayjs";
import dayjs from "dayjs";
import React, { FC } from "react";
// import timezone from "dayjs/plugin/timezone";

// Comment out the line that causes testing issues
// dayjs.extend(timezone);

interface DayViewProps {
  current: Dayjs;
  onDateClick: (day: Dayjs) => void;
  selectedDate: dayjs.Dayjs;
}

const DayView: FC<DayViewProps> = ({ current, onDateClick, selectedDate }) => {
  // Comment out problematic line for tests
  // dayjs.tz.setDefault(state.timezone);
  
  const today = dayjs().startOf('day');
  
  // Helper function to get next N working days
  const getNextWorkingDays = (startDate: dayjs.Dayjs, count: number): dayjs.Dayjs[] => {
    const workingDays: dayjs.Dayjs[] = [];
    let currentDate = startDate;
    
    while (workingDays.length < count) {
      // Skip weekends (Saturday = 6, Sunday = 0)
      if (currentDate.day() !== 0 && currentDate.day() !== 6) {
        workingDays.push(currentDate);
      }
      currentDate = currentDate.add(1, 'day');
    }
    
    return workingDays;
  };
  
  // If today is Saturday or Sunday, start from next Monday
  let startDate = today;
  if (today.day() === 0) { // Sunday
    startDate = today.add(1, 'day'); // Monday
  } else if (today.day() === 6) { // Saturday
    startDate = today.add(2, 'day'); // Monday
  }
  
  // Get the next 5 working days
  const allowedDates = getNextWorkingDays(startDate, 5);
  
  // Check if current date is in the allowed working days
  const isAllowedDate = allowedDates.some(date => date.isSame(current, 'day'));
  
  // Check if it's a weekend
  const isWeekend = current.day() === 0 || current.day() === 6;
  
  // Disable if it's not in allowed dates OR if it's a weekend
  let isDisabled = !isAllowedDate || isWeekend;
  
  let isSelected = current.diff(selectedDate, "day") === 0 && !isDisabled;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isDisabled) {
      onDateClick(current);
    }
  };

  return (
    <button
      id={clsx({ "selected-date": isSelected })}
      onClick={handleClick}
      type="button"
      disabled={isDisabled}
      aria-label={`${current.format("dddd, MMMM D")}`}
      className={clsx("cb-date-day-item", {
        ["cb-selected"]: isSelected,
        ["cb-disabled-dates"]: isDisabled,
      })}
    >
      <div className="cb-date-label">{current.format("D")}</div>
      <div className="cb-day-label">{current.format("ddd")}</div>
    </button>
  );
};

export default DayView;